import {Close} from '@mui/icons-material';
import {Button, Dialog, DialogContent, DialogTitle, IconButton} from '@mui/material';
import {useState} from 'react';
import {QueueJobContent} from '../../__generated__/resolvers-types';
import JobList from './JobList';
import HelpButtonWrapper from '../helpButton/HelpButtonWrapper';
import {HelpTutorialEnum} from '../../variables/helpTutorial';

export interface JobListButtonProps {
  content: QueueJobContent;
  buttonText?: string;
}

export function JobListButton({content, buttonText = 'Show Job List'}: JobListButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <HelpButtonWrapper helpTutorialEnum={HelpTutorialEnum.SHOW_JOB_LIST}>
      <>
        <Button variant="outlined" onClick={() => setOpen(!open)} sx={{width: '100%'}}>
          {buttonText}
        </Button>
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          maxWidth="md"
          fullWidth
          slotProps={{
            paper: {
              sx: {
                minHeight: '80vh',
                maxHeight: '80vh',
                p: 2,
              },
            },
          }}
        >
          <DialogTitle>
            Job List
            <IconButton
              aria-label="close"
              onClick={() => setOpen(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <JobList content={content} />
          </DialogContent>
        </Dialog>
      </>
    </HelpButtonWrapper>
  );
}
